<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: "WalletAuthorization",
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }],
      permission: {
        add: 'walletAuthorization:add',
        update: 'walletAuthorization:update',
        delete: 'walletAuthorization:delete',
        deleteBatch: 'walletAuthorization:deleteBatch'
      },
      url: {
        get: '/walletAuthorization/listByCondition',
        add: '/walletAuthorization/add',
        update: '/walletAuthorization/update',
        delete: '/walletAuthorization/delete/',
        delete_batch: '/walletAuthorization/deleteBatch',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select'
        },
        width: '',
      }, {
        field: 'userId',
        label: '用户ID',
        show: true,
        width: '',
      }, {
        field: 'currency',
        label: '币种',
        show: true,
        width: '',
      }, {
        field: 'walletAddress',
        label: '钱包地址',
        show: true,
        width: '',
      },{
        field: 'createTime',
        label: '时间',
        show: true,
        width: '',
      }],
      operate: [],
      formFields: {
        addTitle: '添加会员授权信息',
        updateTitle: '修改会员授权信息',
        model: [{
          field: 'agentId',
          label: '代理',
          type: 'select',
          selectUrl: '/agent/getAll',
          selectData: [],
          placeholder: '请选择',
          rules: [{
            message: '请选择代理', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        }, {
          field: 'userId',
          label: '用户ID',
          type: 'textarea',
          placeholder: '用户ID',
          rules: [{message: '请输入用户ID', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'currency',
          label: '币种',
          type: 'textarea',
          placeholder: '币种',
          rules: [{message: '请输入币种', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'walletAddress',
          label: '钱包地址',
          type: 'textarea',
          placeholder: '钱包地址',
          rules: [{message: '请输入钱包地址', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }],
      }
    }
  }
}
</script>

<style scoped>

</style>
